module.exports = __webpack_public_path__ + "static/fix_torm-b7ae95279ccbc78bbbe64803e878b876.webp";